import axios from 'axios';
import config from '../_helpers/config';
import { SERVICE_WS } from "./servicesHanu";

const API_URL = config.get('apiUrl');

const axiosInstance = (service =  SERVICE_WS) => {
    return axios.create({
        baseURL: `${API_URL}/${service}`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
    });
}

export {
    axiosInstance,
};